// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3HyVv","text":"SelectPayment_text__IuFRo","title":"SelectPayment_title__p0XOI","btn":"SelectPayment_btn__35xCd"};